import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages/Home.scss';
import heroSection from '../assets/hero-section.png';
import about1 from '../assets/about2.png';
import about2 from '../assets/about1.png';
import { CiLocationOn } from 'react-icons/ci';
import calendrier from '../assets/servicesIcons/calendrier.png';
import comptable from '../assets/servicesIcons/comptable.png';
import fichier from '../assets/servicesIcons/fichier.png';
import recrutement from '../assets/servicesIcons/recrutement.png';
import secretaire from '../assets/servicesIcons/secretaire.png';
import system from '../assets/servicesIcons/system.png';
import traduction from '../assets/servicesIcons/traduction.png';
import image1 from '../assets/image1.png';
import image2 from '../assets/image2.png';
import image3 from '../assets/image3.png';
import flexibilite from '../assets/flexibilite.png';
import mallette from '../assets/mallette.png';
import offre from '../assets/offre.png';
import temps from '../assets/temps.png';
import internationalImage from '../assets/international.png';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth < 768;

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobile]);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container hero-row">
          <div className="hero-col hero-text">
            <h1>{t('home.welcome')}</h1>
            <p>{t('home.description')}</p>
            <Link to="/contact" className="cta-button">{t('home.cta')}</Link>
          </div>
          <div className="hero-col hero-image">
            <img src={heroSection} alt="Télésecrétariat Powerline" className="hero-img-rounded" />
          </div>
        </div>
      </section>

      {/* Company Description Section */}
      <section className="company-desc-section">
        <div className="container">
        <p className="company-desc">
          {t('home.company_desc1')} <span className="blue-link">{t('home.company_desc_style1')}</span> {t('home.company_desc2')}<span className="blue-link">{t('home.company_desc_style2')}</span> {t('home.company_desc3')}
        </p>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
          <div className="about-images">
            <img src={about1} alt="Télésecrétariat illustration 1" />
            <img src={about2} alt="Télésecrétariat illustration 2" />
          </div>
          <div className="about-content">
            <h2>{t('home.about_title')}</h2>
            <p>{t('home.about_content')}</p>
          </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <h2 className="services-title">{t('home.services_title')}</h2>
          <div className="services-grid">
            <div className="services-row">
              <div className="service-card">
                <div className="service-icon">
                  <img src={secretaire} alt={t('home.services.0.title')} />
                </div>
                <div className="service-title">{t('home.services.0.title')}</div>
                <div className="service-desc">{t('home.services.0.desc')}</div>
              </div>
              <div className="service-card">
                <div className="service-icon">
                  <img src={system} alt={t('home.services.1.title')} />
                </div>
                <div className="service-title">{t('home.services.1.title')}</div>
                <div className="service-desc">{t('home.services.1.desc')}</div>
              </div>
              <div className="service-card">
                <div className="service-icon">
                  <img src={traduction} alt={t('home.services.2.title')} />
                </div>
                <div className="service-title">{t('home.services.2.title')}</div>
                <div className="service-desc">{t('home.services.2.desc')}</div>
              </div>
              <div className="service-card">
                <div className="service-icon">
                  <img src={recrutement} alt={t('home.services.3.title')}/>
                </div>
                <div className="service-title">{t('home.services.3.title')}</div>
                <div className="service-desc">{t('home.services.3.desc')}</div>
              </div>
            </div>
            <div className="services-row">
              <div className="service-card">
                <div className="service-icon">
                  <img src={comptable} alt={t('home.services.4.title')}/>
                </div>
                <div className="service-title">{t('home.services.4.title')}</div>
                <div className="service-desc">{t('home.services.4.desc')}</div>
              </div>
              <div className="service-card">
                <div className="service-icon">
                  <img src={calendrier} alt={t('home.services.5.title')} />
                </div>
                <div className="service-title">{t('home.services.5.title')}</div>
                <div className="service-desc">{t('home.services.5.desc')}</div>
              </div>
              <div className="service-card">
                <div className="service-icon">
                  <img src={fichier} alt={t('home.services.6.title')} />
                </div>
                <div className="service-title">{t('home.services.6.title')}</div>
                <div className="service-desc">{t('home.services.6.desc')}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* International Section */}
      <section className="international-section">
        <div className="container international-row">
          <div className="international-text">
            <h2>{t('home.international_title')}</h2>
            <p>{t('home.international_desc')}</p>
          </div>
          <div className="international-illustration-wrapper">
              <img src={internationalImage} alt='international' />
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <div className="container">
          <h2 className="why-title">{t('home.why_choose_us', 'Pourquoi nous choisir ?')}</h2>
          <div className="features-grid">
            <div className="feature-box">
              <div className="feature-icon">
                <img src={flexibilite} alt={t('home.flexibility', 'Flexibilité')} />
              </div>
              <div className="feature-label"><span>01.</span><br /> {t('home.flexibility', 'Flexibilité')}</div>
            </div>
            <div className="feature-box">
              <div className="feature-icon">
                <img src={offre} alt={t('home.adapted_prices', 'Tarifs adaptés')} />
              </div>
              <div className="feature-label"><span>02.</span><br /> {t('home.adapted_prices', 'Tarifs adaptés')}</div>
            </div>
            <div className="feature-box">
              <div className="feature-icon">
                <img src={temps} alt={t('home.time_saving', 'Gain de temps')} />
              </div>
              <div className="feature-label"><span>03.</span><br /> {t('home.time_saving', 'Gain de temps')}</div>
            </div>
            <div className="feature-box">
              <div className="feature-icon">
                <img src={mallette} alt={t('home.expertise', 'Expérience et professionnalisme')} />
              </div>
              <div className="feature-label"><span>04.</span><br /> {t('home.expertise', 'Expérience et professionnalisme')}</div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <div className="container testimonials-row">
          <h2 className="testimonials-title">{t('home.testimonials', 'Témoignages Clients')}</h2>
          <div className="testimonials-content">
            <div className="testimonials-left">
              <div className="testimonials-bubbles-avatars">
                <div className="bubbles-row">
                  <div className="bubble">
                    <div className="bubble-rect"></div>
                    <div className="bubble-tail"></div>
                  </div>
                  <div className="bubble">
                    <div className="bubble-rect"></div>
                    <div className="bubble-tail"></div>
                  </div>
                </div>
                <div className="avatars-row">
                  <div className="avatar" style={{ backgroundImage: `url(${image1})`, zIndex:1 }}></div>
                  <div className="avatar" style={{ backgroundImage: `url(${image2})`, zIndex:2 }}></div>
                  <div className="avatar" style={{ backgroundImage: `url(${image3})`, zIndex:1 }}></div>
                </div>
              </div>
            </div>
            <div className="testimonials-right">
              <div className="testimonial-card">
                <div className="stars">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
                <p>{t('home.testimonial_text', 'J\'ai fait appel à Powerline pour externaliser une partie de mes tâches administratives, et je suis plus que satisfaite de leur service. Leur équipe est réactive, professionnelle et parfaitement organisée. Le fait qu\'ils travaillent à 100 % en ligne rend la collaboration très simple et fluide, même à distance.')}</p>
                <div className="testimonial-author">{t('home.testimonial_author', 'Martin Sutter')}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;